import {
  CriteriaWithPagination,
  EuiButtonIcon,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHealth,
  EuiIcon,
  EuiImage,
  EuiLink,
  EuiTableSelectionType,
  euiPaletteColorBlindBehindText,
} from "@elastic/eui";
import {
  Button,
  Flex,
  Grid,
  Group,
  Input,
  LoadingOverlay,
  Text,
  Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { ReactNode, useEffect, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
import AppAction from "../../../common/AppAction";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblBrand } from "../../../model/TblBrand";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
import UpdateOrderNumberView from "./UpdateOrderNumberView";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React from "react";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { _localization } from "../../../config/location";
import {
  IconFileExport,
  IconPlus,
  IconSearch,
  IconTrash,
} from "@tabler/icons-react";
import { useForm } from "@mantine/form";
import { BASE_API_URL } from "../../../config";
import { useLocation } from "react-router-dom";
import { convertImageDomain } from "../../../const/converhandle";

const visColorsBehindText = euiPaletteColorBlindBehindText();

const optionSearch = [
  {
    value: "Active",
    label: "Kích hoạt",
    color: visColorsBehindText[1],
  },
  {
    value: "Inactive",
    label: "Chưa kích hoạt",
    color: visColorsBehindText[0],
  },
];
const Brand = () => {
  const location = useLocation();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [loading, setLoading] = useState(false);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [error, setError] = useState<string | undefined>();
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [selectedOptions, setSelected] = useState();
  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  const [isSelectedItem, setSelectedItems] = useState<any[]>([]);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [toltal, setTotal] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(0);
  const handleDeleteViewClose = (status: number) => {
    setDeleteViewStatus(status);
  };
  const [data, setData] = useState<TblBrand[]>([]);
  const [message, setMessage] = useState<ReactNode>();
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
    },
  });

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      // {
      //   header: "STT",
      //   accessorKey: "STT",
      //   Cell: ({ row }) => <>{row?.index + 1}</>,
      //   size: 100,
      // },
      {
        accessorKey: "name",
        header: "Tên thương hiệu",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      // {
      //   accessorKey: "brandIndex",
      //   header: "Link index",
      //   Cell: ({ row }) => {
      //     const item = row.original.brandIndex;
      //     return (
      //       <Text>
      //         {item && item.trim() !== "" ? (
      //           <a
      //             href={`${hacomUrl}/brand/${item}`}
      //             target="_blank"
      //             rel="noopener noreferrer"
      //             style={{ color: "#1976d2", textDecoration: "underline" }}
      //           >
      //             Xem trang
      //           </a>
      //         ) : (
      //           <i style={{ color: "#aaa" }}>Không có link</i>
      //         )}
      //       </Text>
      //     );
      //   },
      // },
      {
        accessorKey: "image",
        header: "Logo thương hiệu",
        Cell: ({ row }) => {
          return row.original.image ? (
            <EuiImage
              width={30}
              height={20}
              src={`${convertImageDomain(row.original.imageUrl)}/${
                row.original.image
              }`}
              alt="logo"
            />
          ) : null;
        },
      },
      {
        accessorKey: "letter",
        header: "Lời nhắn",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "product",
        header: "Số sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <>
            <Text fw={500} style={{ color: "blue", marginRight: 4 }}>
              {renderedCellValue}
            </Text>
            <Text>(Sản phẩm)</Text>
          </>
        ),
      },
      {
        accessorKey: "brandPageView",
        header: "Số lượng lượt xem ",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "summary",
        header: "Mô tả tóm tắt",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ordering",
        header: "Thứ tự hiển thị",
        Cell: ({ row }) => {
          return row.original.ordering !== undefined ? (
            <EuiLink
              target="_blank"
              onClick={() =>
                modalChangeOrderBrand(row.original.ordering, row.original)
              }
            >
              {row.original.ordering}
            </EuiLink>
          ) : (
            <EuiLink
              target="_blank"
              onClick={() => modalChangeOrderBrand(0, row.original)}
            >
              {0}
            </EuiLink>
          );
        },
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        Cell: ({ row, renderedCellValue }) => {
          const status = row.original.status;
          return (
            <EuiLink
              onClick={async () => {
                await featuredActive(row.original.id, "status");
              }}
            >
              <EuiHealth color={getStatusColor(status)}>
                {status === "A" ? "Hoạt động" : "Không hoạt động"}
              </EuiHealth>
            </EuiLink>
          );
        },
      },
      {
        accessorKey: "priorityStatus",
        header: "Nổi bật",
        Cell: ({ row }) => {
          const priorityStatus = row.original.priorityStatus;
          return (
            <EuiLink>
              <div
                style={{ display: "flex", alignItems: "center" }}
                onClick={async (e: any) => {
                  open();
                  await featuredActive(row.original.id, "priority");
                }}
              >
                <EuiIcon
                  type="starFilled"
                  color={getStatusColor(priorityStatus + "p")}
                />
                <span style={{ fontSize: "14px", paddingLeft: "5px" }}>
                  {priorityStatus === "A" ? "Nổi bật" : "Không nổi bật"}
                </span>
              </div>
            </EuiLink>
          );
        },
      },
      {
        accessorKey: "Actions",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 100,
        Cell: ({ renderedCellValue, row }) => {
          const online = row.original;
          return (
            <>
              <EuiFlexGroup
                responsive={true}
                wrap={false}
                gutterSize="s"
                alignItems="center"
              >
                <EuiFlexItem grow={false}>
                  <EuiButtonIcon
                    iconType="documentEdit"
                    aria-label="Dashboard"
                    color="success"
                    onClick={() => handleEditData(row.original.id)}
                  />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  <EuiButtonIcon
                    iconType="trash"
                    color="danger"
                    onClick={() => deleteItem(row.original.id)}
                  />
                </EuiFlexItem>
              </EuiFlexGroup>
            </>
          );
        },
      },
    ],
    []
  );

  const fetchDataBrand = async (
    index: number,
    size?: number,
    keyWord?: string,
    inActive?: boolean
  ) => {
    setMessage("Đang lấy dữ liệu...");
    setLoading(true);
    setData([]);
    setError(undefined);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    try {
      let urlSearch = `${API_ROUTE.GET_LIST_BRAND}?Skip=${
        index * (size ?? 0)
      }&Take=${size}`;
      if (formSeachInput.getValues().KeySearch)
        urlSearch += `&KeySearch=${formSeachInput.getValues().KeySearch}`;

      if (!isNullOrUndefined(inActive))
        urlSearch = urlSearch + `&Active=` + inActive;

      let callapi = await repository.get<MessageResponse<any>>(urlSearch);
      if (
        isNullOrUndefined(callapi) ||
        isNullOrUndefinedArry(callapi?.data?.lists)
      ) {
        setMessage("Không có dữ liệu");
        setRowCount(0);
      } else {
        setData(callapi?.data?.lists ?? []);
        setPagination({
          ...pagination,
        });
        setRowCount(callapi?.data?.count ?? 0);
      }
      return callapi?.data;
    } catch (error: any) {
      setError("Có lỗi xảy ra khi tải dữ liệu !");
      return null;
    } finally {
      setLoading(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...formSeachInput.getValues(),
          pageSize: pagination.pageSize,
          pageIndex: pagination.pageIndex,
        })
      );
    }
  };

  const featuredActive = async (id: number, type: string, order?: number) => {
    if (id < 1) NotificationExtension.Fails("Mã danh mục không tồn tại !");
    else {
      setLoading(true);
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      try {
        let urlSearch =
          type === "status"
            ? API_ROUTE.MODIFY_BRAND_STATUS + id
            : type === "priority"
            ? API_ROUTE.MODIFY_BRAND_PRIORITY + id
            : type === "order"
            ? API_ROUTE.MODIFY_BRAND_ORDER + id + "&order=" + order
            : "";
        let callapi = await repository.post<MessageResponse<boolean>>(
          urlSearch
        );
        close();
        if (isNullOrUndefined(callapi)) {
          NotificationExtension.Fails(
            "Thao tác không thành công, xin vui lòng thử lại !"
          );
        } else {
          if (callapi?.success) {
            NotificationExtension.Success("Thao tác thành công !");
            await fetchDataBrand(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            );
          } else NotificationExtension.Fails("Thao tác thất bại !");
        }
        return callapi?.data;
      } catch (error: any) {
        setError("Có lỗi xảy ra khi tải dữ liệu !");
        throw new Error(error);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleEditData = async (id: any) => {
    if (id) {
      editItem(id);
    } else {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    }
  };

  const onTableChange = async ({
    page: { index, size },
  }: CriteriaWithPagination<any>) => {
    setPagination({ ...pagination, pageIndex: index, pageSize: size });
  };

  const onChange = (selectedOptions: any) => {
    setSelected(selectedOptions);
    if (!isNullOrUndefinedArry(selectedOptions)) {
      const value = selectedOptions[0].value;
      if (!isNullOrUndefined(value))
        setParamSearch({ ...paramSearch, inActive: value });
    } else setParamSearch({ ...paramSearch, inActive: undefined });
  };

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event?.target?.value;
    if (!isNullOrUndefined(key))
      setParamSearch({ ...paramSearch, keyWord: key });
  };

  const onSelectionChange = (selectedItems: any[]) => {
    setSelectedItems(selectedItems);
  };
  const selection: EuiTableSelectionType<any> = {
    selectable: (user: any) => true,
    selectableMessage: (selectable: boolean) =>
      !selectable ? "User is currently offline" : "",
    onSelectionChange,
  };

  const getStatusColor = (status: any) => {
    switch (status) {
      case "I":
        return "danger";
      case "A":
        return "green";
      case "Ap":
        return "#f9fd04";
      case "Ip":
        return "gray";
      default:
        return "subdued";
    }
  };

  const modalChangeOrderBrand = (orderNumber: number, brand: TblBrand) => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Cập nhật thứ tự hiển thị thương hiệu</Title>
          </div>
        </>
      ),
      children: (
        <UpdateOrderNumberView
          orderNumber={orderNumber}
          brand={brand}
          featuredActive={featuredActive}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới thương hiệu</Title>
          </div>
        </>
      ),
      children: (
        <CreateView onClose={handleDeleteViewClose} load={deleteViewStatus} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });

  const openModalEdit = () => {
    if (
      isSelectedItem &&
      (isSelectedItem.length < 1 || isSelectedItem.length > 1)
    )
      NotificationExtension.Warn("Xin vui lòng chọn 1 sản phẩm để chỉnh sửa !");
    else {
      editItem(isSelectedItem[0].id);
    }
  };

  const openModalDelete = () => {
    // Lấy các ID của row được chọn
    const selectedIds = Object.keys(rowSelection)
      .filter((key) => rowSelection[key])
      .map((key) => data[parseInt(key)].id);
    if (selectedIds.length === 0) {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu để xóa!");
      return;
    } else {
      const ids = selectedIds;
      deleteItem(ids);
    }
  };

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xoá thương hiệu</Title>
        </>
      ),
      children: (
        <DeleteView
          onSearch={() =>
            fetchDataBrand(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa thương hiệu</Title>
        </>
      ),

      children: (
        <EditView
          id={id}
          onClose={handleDeleteViewClose}
          load={deleteViewStatus}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  }

  const fetchData = async () => {
    await fetchDataBrand(
      pagination.pageIndex,
      pagination.pageSize,
      paramSearch?.keyWord,
      paramSearch?.inActive
    );
  };
  useEffect(() => {
    fetchData();
    setRowSelection({});
  }, [pagination.pageIndex, pagination.pageSize, deleteViewStatus]);
  const exportExcel = async () => {
    open(); // Hiển thị loading
    try {
      // Khởi tạo URL với các tham số phân trang
      const params = new URLSearchParams();

      // Thêm thông tin phân trang
      params.append(
        "Skip",
        (pagination.pageIndex * pagination.pageSize).toString()
      );
      params.append("Take", pagination.pageSize.toString());

      // Lấy giá trị từ form và thêm vào params nếu có giá trị
      const { KeySearch } = formSeachInput.getValues();
      if (KeySearch) params.append("KeySearch", KeySearch);
      // Xây dựng URL API cuối cùng
      const baseUrl = `/ExportExcel/export-brands-to-excel?${params.toString()}`;

      const _url = BASE_API_URL + baseUrl;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");

      // Gọi API
      const response = await fetch(fullUrl.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });
      // Kiểm tra trạng thái HTTP
      if (!response.ok) {
        const errorResponse = await response.json(); // Parse lỗi từ API
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
      }

      // Xử lý file Excel
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const filename = "danh-sach-thuong-hieu.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error: any) {
      console.error("Error:", error);
      // Hiển thị thông báo lỗi
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!"
      );
    } finally {
      close(); // Đóng loading
    }
  };
  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    enableRowNumbers: true,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-numbers"],
        right: ["status", "priorityStatus", "Actions"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      pagination,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    positionToolbarAlertBanner: "bottom",
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (130 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  // useEffect(() => {
  //   if (_searchJson) {
  //     setPagination({
  //       pageIndex: _searchJson.pageIndex,
  //       pageSize: _searchJson.pageSize,
  //     });
  //   }
  // }, []);

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadCrumb />
      </Flex>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <Grid justify="space-between" align="center" mb={10} mt={10}>
        <Grid.Col span="auto">
          <Group gap="sm">
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Group>
        </Grid.Col>
        <Grid.Col span="content">
          <Group justify="flex-end">
            <Button
              leftSection={<IconPlus size={14} />}
              onClick={openModal}
              color="blue"
              variant="outline"
            >
              Thêm mới
            </Button>
            {/* <Button
              leftSection={<IconFileExport size={14} />}
              onClick={exportExcel}
              color="yellow"
              variant="outline"
            >
              Export Excel
            </Button> */}
            <Button
              leftSection={<IconTrash size={14} />}
              onClick={openModalDelete}
              color="red"
              variant="outline"
            >
              Xóa (Đã chọn)
            </Button>
          </Group>
        </Grid.Col>
      </Grid>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default Brand;
